export enum UsersRoutes {
  root = 'users',
  main = '',
  users = 'tenant-users',
  clients = 'tenant-clients',
  info = 'info',
}
